import { render, staticRenderFns } from "./DataNotes.vue?vue&type=template&id=378b438c&scoped=true"
var script = {}
import style0 from "./DataNotes.vue?vue&type=style&index=0&id=378b438c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378b438c",
  null
  
)

export default component.exports